import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';
import { useQuantityPickerStore } from '@store/uiStore';
import type { Product } from '@/types';

export function useAddToCart(redirectPath = '/') {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();
  const openQuantityPicker = useQuantityPickerStore((s) => s.openQuantityPicker);

  const requestAdd = (product: Product) => {
    if (!isAuthenticated || user?.role !== 'restaurant') {
      navigate(`/login?redirect=${encodeURIComponent(redirectPath)}`);
      return;
    }
    openQuantityPicker(product);
  };

  return { requestAdd };
}
